
<div [class.main-login-extrasmall]="this.isExtraSmall">
    <!-- logo -->
    <div class="logo-container d-flex justify-content-center align-items-center" *ngIf="!this.isExtraSmall">
        <img src="../../../assets/imgs/login-rectangle.svg">
        <img src="../../../assets/imgs/login-logo.svg" height="90" width="130" class="login-icon-medium">
    </div>

    <div class="w-100 d-flex justify-content-center login-container-extra-small" *ngIf="this.isExtraSmall">
        <img src="../../../assets/imgs/login-logo.svg" height="80" width="250">
    </div>

    <div class="login-container" [ngClass]="{
        'login-container-full': !this.isExtraSmall
    }">
        <!-- header -->
        <header class="login-header th-bg-main d-flex align-items-center" *ngIf="!this.isExtraSmall">
            <div class="ms-auto btn-gen-estcuenta-container d-flex align-items-center">
                <div class="services-container">
                    <ng-container #anchorContainer></ng-container>
                </div>
                <div class="pin-button">
                  <ng-container #helpCenterBtn></ng-container>
                  <!--   <ng-container #pinBtn></ng-container> -->
                </div>
                <div>
                    <ng-container #estadoCuentaBtn></ng-container>
                </div>
            </div>
        </header>

        <!-- content -->
        <div class="d-flex justify-content-center w-100" [ngClass]="{
            'flex-column' : this.isExtraSmall,
            'login-content h-100' : !this.isExtraSmall
        }">

            <!-- banner and carousel -->
            <div class="w-100 content-banner login-child-banner" *ngIf="this.isMedium">
                <div class="w-100 h-100 d-flex justify-content-center align-items-center">    
                    <div id="carouselExampleIndicators" class="carousel-container carousel slide w-100 position-relative" data-bs-ride="carousel">

                        <!-- SVA information -->
                        <div class="sva-information-container w-100">
                            <div class="d-flex flex-column align-items-center">
                                <div class="d-flex flex-column gap-3 mb-3">
                                    <div class="th-text-white bs-sc-text-title">
                                        <span>
                                            Le protegemos a usted y a los suyos
                                        </span>
                                    </div>
                                    <div class="th-text-white bs-paragraph text-center">
                                        <span>
                                            Descubra cómo beneficiarse con la Sociedad de Seguros de Vida.
                                        </span>
                                    </div>
                                </div>
    
                                <div class="sva-information-button">
                                    <a href="https://sociedaddesegurosdevida.cr/la-poliza" target="_blank">
                                        <span class="th-text-main bs-main-and-action">
                                            CONOCER MÁS
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="carousel-indicators">
                          <button type="button" 
                                  data-bs-target="#carouselExampleIndicators" 
                                  data-bs-slide-to="0" 
                                  class="active carousel-step-button" 
                                  aria-current="true"
                                  aria-label="Slide 1"></button>
                          <button type="button" 
                                  class="carousel-step-button"
                                  data-bs-target="#carouselExampleIndicators"
                                  data-bs-slide-to="1" 
                                  aria-label="Slide 2"></button>
                          <button type="button"
                                  class="carousel-step-button"
                                  data-bs-target="#carouselExampleIndicators"
                                  data-bs-slide-to="2"
                                  aria-label="Slide 3"></button>
                        </div>
                        <div class="carousel-inner h-100">
                          <div class="carousel-item h-100 active" data-bs-interval="2500">
                            <img src="../../../assets/imgs/sucursal.webp"
                                 class="d-block h-100 carousel-image" alt="familia">
                          </div>
                          <div class="carousel-item h-100" data-bs-interval="2500">
                            <img src="../../../assets/imgs/maestra.webp" 
                                 class="d-block h-100 carousel-image" alt="maestra">
                          </div>
                          <div class="carousel-item h-100" data-bs-interval="2500">
                            <img src="../../../assets/imgs/familia2.webp" 
                                class="d-block h-100 carousel-image" alt="famila">
                          </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- login form -->
            <div class="flex-content w-100 d-flex flex-column align-items-center login-child-form"
                [ngClass]="{
                    'justify-content-center' : this.isMedium,
                    'small-login-form-container' : this.isSmall
                }">

                <!-- titles -->
                <div [ngClass]="{
                    'extra-small-content' : this.isExtraSmall,
                    'd-flex justify-content-center align-items-center flex-column' : true
                }">
                    <span class="bs-h1 main-header-form th-text-main text-center">Le damos la bienvenida a la</span>
                    <span class="bs-h1 main-header-form th-text-secondary">Sucursal Virtual</span>

                    <span class="bs-h1 th-text-main secondary-header-form">Inicie Sesión</span>
                    <span class="bs-paragraph th-text-gray-paragraphs" [ngClass]="{
                        'text-center' : this.isExtraSmall
                    }">
                        Digite la información solicitada para ingresar a su cuenta.
                    </span>
                </div>

                <!-- inputs -->
                <div class="d-flex flex-column" [ngClass]="{
                    'input-form-container' : !this.isExtraSmall,
                    'extra-small-content mt-4' : this.isExtraSmall
                }">
                    <div class="w-100">
                        <ng-container #userIdInput></ng-container>
                    </div>
                    <div class="w-100 password-input">
                        <ng-container #passwordInput></ng-container>
                    </div>

                    <!-- forgot password message -->
                    <div class="ms-auto">
                        <span class="th-text-main bs-button reset-password-container" (click)="resetPassword()">¿Ha olvidado su contraseña?</span>
                    </div>

                    <!-- erorr message if neccesary -->
                    <div class="error-message-container" *ngIf="this.errorMessage">
                        <ng-container #errorMessageContainer></ng-container>
                    </div>
                </div>

                <!-- sign in button container -->
                <div (click)="signIn()" [ngClass]="{
                    'signin-button-container': !this.errorMessage,
                    'signin-button-container-error': this.errorMessage,
                    'extra-small-content' : this.isExtraSmall,
                    'sign-in-button-container': !this.isExtraSmall
                }">
                    <ng-container #signInBtn></ng-container>
                    <div class="d-flex justify-content-center mt-3">
                        <span class="bs-paragraph th-text-gray-paragraphs">¿Es nuevo usuario? 
                            <span class="bs-paragraph th-text-main reset-password-container fw-bold" (click)="createAccount()">Crear cuenta</span>
                        </span>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="w-100 mt-auto bottom-banner-extra-small th-bg-main d-flex justify-content-center align-items-center flex-column" 
            *ngIf="this.isExtraSmall">
            <div class="services-bottom-container">
                <ng-container #anchorContainer></ng-container>
            </div>
            <div class="bottom-buttons-container d-flex flex-column gap-3">

              <div class="ms-auto">
                <span class="th-text-main bs-button reset-password-container" (click)="resetPassword()">¿Ha olvidado su contraseña?</span>
              </div>
              <!--  <ng-container #pinBottomBtn></ng-container>  -->
              <ng-container #helpCenterBottomBtn></ng-container>
              <ng-container #estadoCuentaBottomBtn></ng-container>
            </div>
      </div>
  </div>
  <!-- pin pop up container -->
              <div class="modal-overlay" *ngIf="getIsOpen()">
                <div class="custom-modal-container th-bg-white position-relative modal-size"
                     [style.width]="this.getWidth()+'px'">

                  <!-- close button -->
                  <div class="close-button-container"
                       *ngIf="this.getCanBeClosed()"
                       (click)="this.closePopUp()">
                    <img [src]="this.closeIconPath">
                  </div>
                  <!-- header -->
                  <div class="modal-header-container">

                    <div [ngClass]="{
                    'extra-small-content' : this.isExtraSmall,
                    'd-flex justify-content-center align-items-center flex-column' : true}">
                      <span class="bs-h1 th-text-main secondary-header-form" [ngClass]="{
                        'text-center' : this.isExtraSmall}">Generar pin de seguridad</span>
                      <span class="bs-paragraph th-text-gray-paragraphs" [ngClass]="{
                        'text-center' : this.isExtraSmall}">
                        Ingrese su número de identificación y complete el recaptcha para poder recibir su pin de seguridad a sus medios de contacto registrados.
                      </span>
                    </div>

                  </div>

                  <!-- content -->
                  <div class="d-flex flex-column" [ngClass]="{
            'input-form-container' : !this.isExtraSmall,
            'extra-small-content mt-4' : this.isExtraSmall}">

                    <div class="margin-input">
                      <ng-container #userPinDocInput></ng-container>
                    </div>


                    <div class="w-100">
                      <ng-container #recaptchaContainer></ng-container>
                    </div>

                    <!-- erorr message if neccesary -->
                    <div class="error-message-container" *ngIf="this.errorPopUpFields">
                      <ng-container #errorFieldsContainer></ng-container>
                    </div>
                  </div>

                  <div [disabled]="isButtonDisabled" (click)="sendPin()" [ngClass]="{
                'signin-button-container': !this.errorMessage,
                'signin-button-container-error': this.errorMessage,
                'extra-small-content' : this.isExtraSmall,
                'sign-in-button-container': !this.isExtraSmall
            }">
                    <ng-container #helpCenterBtn></ng-container>
                    <!--  <ng-container #sendPinBtn></ng-container> -->
                  </div>
                </div>
              </div>

              <!-- estado de cuenta pop up container -->
              <div class="modal-overlay" *ngIf="this.isEstCuentPopUpOpen">
                <div class="custom-modal-container th-bg-white position-relative modal-size"
                     [style.width]="this.getWidth()+'px'">

                  <!-- close button -->
                  <div class="close-button-container"
                       *ngIf="this.getCanBeClosed()"
                       (click)="this.closeEstCuentaPopup()">
                    <img [src]="this.closeIconPath">
                  </div>
                  <!-- header -->
                  <div class="modal-header-container">

                    <div [ngClass]="{
                    'extra-small-content' : this.isExtraSmall,
                    'd-flex justify-content-center align-items-center flex-column' : true}">
                      <span class="bs-h1 th-text-main secondary-header-form" [ngClass]="{
                        'text-center' : this.isExtraSmall}">Generar estado de cuenta</span>
                      <span class="bs-paragraph th-text-gray-paragraphs" [ngClass]="{
                        'text-center' : this.isExtraSmall}">
                        Ingrese su número de identificación para generar y recibir su estado de cuenta en el correo electrónico registrado.
                      </span>
                    </div>
                  </div>

                  <!-- content -->
                  <div class="d-flex flex-column" [ngClass]="{
            'input-form-container' : !this.isExtraSmall,
            'extra-small-content mt-4' : this.isExtraSmall}">

                    <div class="margin-input">
                      <ng-container #userEstCuentaIdInput></ng-container>
                    </div>

                    <div class="w-100">
                      <ng-container #recaptchaContainerEstCuenta></ng-container>
                    </div>

                    <!-- erorr message if neccesary -->
                    <div class="error-message-container" *ngIf="this.errorPopUpFields">
                      <ng-container #errorFieldsContainer></ng-container>
                    </div>
                  </div>

                  <div [disabled]="isButtonDisabled" (click)="sendPin()" [ngClass]="{
            'signin-button-container': !this.errorMessage,
            'signin-button-container-error': this.errorMessage,
            'extra-small-content' : this.isExtraSmall,
            'sign-in-button-container': !this.isExtraSmall
        }">
                    <ng-container #sendEstCuenta></ng-container>
                  </div>
                </div>
              </div>

              <ng-container #dialogContainer></ng-container>

              <div *ngIf="socialMediaVisiable" class="redes" [@fadeInOut]>
                <a href="https://www.callmyway.com/Welcome/ClickToCallSupport/e32a84f6848c01d42d00b7bde3a4bf3b"
                   target="_blank" onclick="gtag('event', 'clickCallMyWay');" class="contact-circle" (click)="toggleSsmnContacts()">
                  <i class="fa fa-phone"></i>
                </a>
                <a href="https://webchat.sociedaddesegurosdevida.cr/ssvmn/webchat.php" target="_blank"
                   onclick="gtag('event', 'clickContactChat');" class="contact-circle" (click)="toggleSsmnContacts()">
                  <i class="fa fa-comments"></i>
                </a>
              </div>

              <div class="ssvmn-contacs-container contact-circle d-flex justify-content-center align-items-center" (click)="toggleSsmnContacts()">
                <img class="customer-serviceimg" src="../assets/imgs/customer-service.png">
              </div>
